import { usePrivateMutation as useMutation } from "@/lib/query/core/use-private-mutation";
import { useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminSubscriptions } from "@/lib/query/core/invalidation";

type DeleteSubscriptionPlanInput = {
  subscriptionId: string;
};

export function useDeleteSubscriptionPlanMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ subscriptionId }: DeleteSubscriptionPlanInput) =>
      apiJsonClient<{ success: true }>(
        endpoints.admin.subscriptionById(subscriptionId),
        { method: "DELETE" },
      ),
    onSuccess: async () => {
      await invalidateAdminSubscriptions(queryClient);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
